/* NOTICE IE11 support */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/app';
import * as serviceWorker from './serviceWorker';
import { AppProviders } from './context';

import './i18nextInit';

ReactDOM.render(
  <AppProviders>
    <React.Suspense fallback="loading">
      <App />
    </React.Suspense>
  </AppProviders>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
